export const KS_CONTACT = {
    whatsapp: "919919899198",
    phone: "+919919899198",
    phoneDisplay: "+91 99198 99198",
    website: "https://shreekshetrapal.in",
};

export const kshetrapalDeveloper = {
    overline: "The Developer",
    title: "Shree Kshetrapal Infra LLP",
    tagline:
        "Premium commercial and residential developer from Bhuj, Kutch, Gujarat.",
    story: [
        "Shree Kshetrapal Infra LLP is a Bhuj-based real-estate developer building premium commercial destinations and residential communities across Kutch, Gujarat. Their stated mission is to be the most trusted name in real estate globally.",
        "The developer's focus spans retail and office destinations on Bhuj's key corridors, a plotted commercial & industrial park on the Bhuj–Anjar highway, and planned residential communities — with an emphasis on quality construction, security and well-planned infrastructure.",
    ],
    portfolio: [
        { name: "Shree Kshetrapal Landmark", tag: "Bhuj" },
        { name: "Shree Kshetrapal Prime", tag: "Bhuj" },
        { name: "Shree Kshetrapal Arcade", tag: "Bhuj" },
        { name: "Kshetrapal Square I", tag: "Bhuj" },
        { name: "Kshetrapal Square II", tag: "Bhuj" },
        { name: "Kshetrapal Icon", tag: "Bhuj" },
        { name: "Shree Kshetrapal Residency", tag: "Bhuj" },
    ],
    note: "Developer profile compiled from information published by Shree Kshetrapal Infra LLP on shreekshetrapal.in. Please verify all details directly with the developer.",
};

export const buildFaqs = (projectName) => ({
    type: "faqs",
    overline: "Questions",
    title: "Asked, and answered.",
    items: [
        {
            q: `What is the price in ${projectName}?`,
            a: "Prices, payment plans and current availability are shared directly by the developer. Tap the WhatsApp or Call button on this page to get them straight from the Shree Kshetrapal team.",
        },
        {
            q: "Where can I verify RERA and approvals?",
            a: "Ask the developer directly for RERA registration and approval details for this project, and verify them independently on the official Gujarat RERA portal (gujrera.gujarat.gov.in) before making any decision.",
        },
        {
            q: "Can I schedule a site visit?",
            a: `Yes — message the developer on WhatsApp or call ${KS_CONTACT.phoneDisplay} to arrange a site visit at a time that suits you.`,
        },
    ],
});
